import { render, staticRenderFns } from "./VehicleGroupTable.vue?vue&type=template&id=1ec36c43"
import script from "./VehicleGroupTable.vue?vue&type=script&lang=js"
export * from "./VehicleGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports